// extracted by mini-css-extract-plugin
export default {"Page404":"Page404_Page404__D+RWg","TopFridgeImg":"Page404_TopFridgeImg__5oVDf","Content":"Page404_Content__wYri7"};